import React from 'react'
import PropTypes from 'prop-types'
import useBoundingRect from 'js/hooks/useBoundingRect'

import LogoApple from '!!@svgr/webpack!media/logo-apple.svg'
import LogoAndroid from '!!@svgr/webpack!media/logo-android.svg'
import LogoPlay from '!!@svgr/webpack!media/logo-google-play.svg'

function Logo({ logo, ...props }) {
  if (logo === 'apple') return <LogoApple {...props} />
  if (logo === 'android') return <LogoAndroid {...props} />
  if (logo === 'play') return <LogoPlay {...props} />
}

Logo.propTypes = {
  logo: PropTypes.oneOf(['apple', 'android', 'play']),
}

export function Award({ title, subtitle, year, logo }) {
  return (
    <svg
      width="157"
      height="99"
      viewBox="0 0 157 99"
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: 'auto', width: '100%', color: '#BD9E54' }}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M114.08 98.953c2.124-2.15 3.816-3.7 5.079-4.649 1.263-.949 3.035-2.002 5.318-3.16 1.393 1.803 3.036 2.856 4.93 3.16 1.892.303 5.259.054 10.102-.748-2.406-1.548-4.331-2.54-5.777-2.976-1.445-.437-3.869-.532-7.27-.286l5.065-3.612c2.057 1.347 3.992 2.02 5.807 2.02 1.814 0 4.721-.673 8.721-2.02-2.433-1.264-4.452-2.004-6.056-2.218-1.604-.215-3.693-.026-6.267.567l3.684-4.239c2.158 1.08 4.09 1.504 5.797 1.274 1.706-.229 4.369-1.27 7.989-3.126-2.637-.663-4.719-.995-6.247-.995-1.529 0-3.515.332-5.959.995l3.101-4.77c2.048.634 3.865.634 5.454 0 1.058-.423 2.465-.568 4.277-1.936.606-.457 1.62-1.513 3.04-3.166-3.221.007-5.487.187-6.797.542-1.31.355-2.944 1.23-4.903 2.624l2.122-4.861c2.52-.212 4.49-.818 5.911-1.82.853-.6 2.273-1.266 3.447-2.655.523-.618 1.244-1.83 2.163-3.635-2.102.24-3.763.642-4.983 1.203-1.22.561-3.019 1.81-5.396 3.745l1.12-4.948c2.601-.369 4.436-1.097 5.505-2.184.644-.656 1.905-1.829 2.682-3.448.342-.713.7-1.98 1.072-3.8-1.479.533-2.73 1.19-3.754 1.972-1.024.783-2.686 2.353-4.986 4.71v-3.921c2.034-1.347 3.488-2.766 4.362-4.257.875-1.491 1.686-3.936 2.434-7.333-1.599.994-2.82 2.04-3.665 3.138-.845 1.098-1.889 2.995-3.13 5.691l-.52-6.135c2.138-1.665 3.564-3.271 4.276-4.816.713-1.546 1.297-4.3 1.753-8.26-1.704 1.635-2.965 3.09-3.783 4.363-.819 1.274-1.941 3.28-3.366 6.02l-.377-4.944c1.956-1.967 3.204-3.78 3.743-5.44.539-1.66.705-4.199.498-7.617-1.629 1.315-2.744 2.628-3.346 3.938-.602 1.31-1.155 3.63-1.66 6.96l-1.209-5.074c1.549-2.147 2.49-4.089 2.824-5.824.334-1.736.334-4.686 0-8.85-1.516 2.441-2.457 4.29-2.824 5.547-1.119 3.828-.913 7.241-.913 7.241l-2.23-4.567c1.411-2.146 2.17-3.823 2.275-5.031.514-5.894-.956-10.082-.956-10.082-1.215 2.348-1.967 4.302-2.258 5.863-.251 1.349-.311 3.76-.18 7.23l-1.854-3.868c.2-3.329.2-5.52 0-6.573-.987-5.188-2.52-6.668-2.52-6.668-.385 2.528-.514 4.532-.388 6.011.092 1.08.55 2.914 1.372 5.503l-2.697-3.529c-.272-2.472-.537-4.143-.794-5.014C131.608 1.72 130.41 0 130.41 0c.15 2.466.346 4.35.586 5.653.165.9.576 2.32 1.235 4.258-2.291-2.886-3.864-4.71-4.718-5.47-3.635-3.237-5.255-3.41-5.255-3.41 1.448 2.394 2.679 4.122 3.694 5.184 1.057 1.106 2.934 2.632 5.63 4.575-1.684-.48-3.087-.773-4.21-.879-1.122-.106-2.826-.106-5.114 0 1.82 1.075 3.22 1.732 4.203 1.968 3.564.86 6.476.607 6.476.607l3.154 3.611c-2.569-.558-4.267-.872-5.095-.942-4.559-.388-5.977 0-5.977 0 2.276 1.163 4.073 1.892 5.39 2.187 2.916.653 6.924.572 6.924.572l1.96 3.23c-1.566-.514-2.848-.777-3.848-.79-4.442-.057-8.072.636-8.072.636 2.94 1.14 5.06 1.811 6.358 2.012 3.405.526 6.267-.058 6.267-.058l2.354 4.867c-1.903-.96-3.365-1.51-4.388-1.647-4.579-.617-7.852 0-7.852 0 3.403 1.945 5.831 3.112 7.286 3.502 2.32.62 5.814 0 5.814 0l1.226 5.317c-1.335-.909-2.502-1.456-3.502-1.64-4.303-.793-8.235-.523-8.235-.523 2.925 2.096 5.023 3.337 6.294 3.724 3.227.98 5.959 0 5.959 0l.833 5.459c-1.53-1.065-2.675-1.68-3.435-1.845-5.128-1.116-8.06-.656-8.06-.656 3.184 2.32 5.398 3.718 6.644 4.194 3.292 1.258 5.495.444 5.495.444l.484 5.984c-1.526-1.631-2.76-2.694-3.703-3.189-3.728-1.954-6.936-2.388-6.936-2.388 1.99 2.682 3.544 4.444 4.66 5.284 2.745 2.068 6.013 2.754 6.013 2.754l.088 4.494c-.928-1.297-1.794-2.227-2.6-2.793-1.336-.94-3.682-2.266-7.04-3.98 1.219 2.958 2.399 5.027 3.54 6.207 1.14 1.18 2.846 2.097 5.117 2.75l-1.1 5.484c-.56-1.725-1.14-2.934-1.742-3.626-1.07-1.228-2.995-2.9-5.778-5.015 1.134 3.35 2.143 5.685 3.024 7.007.881 1.322 2.208 2.487 3.98 3.498l-2.182 4.963c-.042-1.619-.496-3.21-1.365-4.774-.868-1.564-2.468-3.676-4.8-6.334.01 2.393.122 4.088.337 5.088.252 1.174 1.12 2.611 1.38 3.347.593 1.677 1.636 3.18 3.128 4.509l-2.972 4.535c-.056-2.116-.37-3.937-.94-5.464-.57-1.526-1.668-3.484-3.293-5.87-.12 3.747-.016 6.447.313 8.102.329 1.655 1.124 3.475 2.384 5.46l-3.491 3.582c.111-2.893.068-4.856-.13-5.892-1.005-5.273-2.397-7.364-2.397-7.364-.477 3.51-.68 6.176-.611 7.998.06 1.556.459 3.957 1.197 7.202l-5.044 3.596c.832-2.475 1.306-4.085 1.42-4.831.34-2.205.037-5.502-.911-9.893-1.114 2.773-1.816 5.044-2.107 6.814-.167 1.016-.71 3.741-.63 5.386.04.814.11 1.868.212 3.162-2.29 1.392-4.081 2.6-5.371 3.623-1.29 1.022-3.044 2.625-5.263 4.808l.777.59zM42.92 98.953c-2.124-2.15-3.816-3.7-5.079-4.649-1.263-.949-3.035-2.002-5.318-3.16-1.393 1.803-3.036 2.856-4.93 3.16-1.892.303-5.259.054-10.102-.748 2.406-1.548 4.331-2.54 5.777-2.976 1.445-.437 3.869-.532 7.27-.286l-5.065-3.612c-2.057 1.347-3.992 2.02-5.807 2.02-1.814 0-4.721-.673-8.721-2.02 2.433-1.264 4.452-2.004 6.056-2.218 1.604-.215 3.693-.026 6.267.567l-3.684-4.239c-2.158 1.08-4.09 1.504-5.797 1.274-1.706-.229-4.369-1.27-7.989-3.126 2.637-.663 4.719-.995 6.247-.995 1.529 0 3.515.332 5.959.995l-3.101-4.77c-2.048.634-3.865.634-5.454 0-1.058-.423-2.465-.568-4.277-1.936-.606-.457-1.62-1.513-3.04-3.166 3.221.007 5.487.187 6.797.542 1.31.355 2.944 1.23 4.903 2.624l-2.122-4.861c-2.52-.212-4.49-.818-5.911-1.82-.853-.6-2.273-1.266-3.447-2.655-.523-.618-1.244-1.83-2.163-3.635 2.102.24 3.763.642 4.983 1.203 1.22.561 3.019 1.81 5.396 3.745l-1.12-4.948c-2.601-.369-4.436-1.097-5.505-2.184-.644-.656-1.905-1.829-2.682-3.448-.342-.713-.7-1.98-1.072-3.8 1.479.533 2.73 1.19 3.754 1.972 1.024.783 2.686 2.353 4.986 4.71v-3.921c-2.034-1.347-3.488-2.766-4.362-4.257-.875-1.491-1.686-3.936-2.434-7.333 1.599.994 2.82 2.04 3.665 3.138.845 1.098 1.889 2.995 3.13 5.691l.52-6.135c-2.138-1.665-3.564-3.271-4.276-4.816-.713-1.546-1.297-4.3-1.753-8.26 1.704 1.635 2.965 3.09 3.783 4.363.819 1.274 1.941 3.28 3.366 6.02l.377-4.944c-1.956-1.967-3.204-3.78-3.743-5.44-.539-1.66-.705-4.199-.498-7.617 1.629 1.315 2.744 2.628 3.346 3.938.602 1.31 1.155 3.63 1.66 6.96l1.209-5.074c-1.549-2.147-2.49-4.089-2.824-5.824-.334-1.736-.334-4.686 0-8.85 1.516 2.441 2.457 4.29 2.824 5.547 1.119 3.828.913 7.241.913 7.241l2.23-4.567c-1.411-2.146-2.17-3.823-2.275-5.031-.514-5.894.956-10.082.956-10.082 1.215 2.348 1.967 4.302 2.258 5.863.251 1.349.311 3.76.18 7.23l1.854-3.868c-.2-3.329-.2-5.52 0-6.573.987-5.188 2.52-6.668 2.52-6.668.385 2.528.514 4.532.388 6.011-.092 1.08-.55 2.914-1.372 5.503l2.697-3.529c.272-2.472.537-4.143.794-5.014C25.392 1.72 26.59 0 26.59 0c-.15 2.466-.346 4.35-.586 5.653-.165.9-.576 2.32-1.235 4.258 2.291-2.886 3.864-4.71 4.718-5.47 3.635-3.237 5.255-3.41 5.255-3.41-1.448 2.394-2.679 4.122-3.694 5.184-1.057 1.106-2.934 2.632-5.63 4.575 1.684-.48 3.087-.773 4.21-.879 1.122-.106 2.826-.106 5.114 0-1.82 1.075-3.22 1.732-4.203 1.968-3.564.86-6.476.607-6.476.607l-3.154 3.611c2.569-.558 4.267-.872 5.095-.942 4.559-.388 5.977 0 5.977 0-2.276 1.163-4.073 1.892-5.39 2.187-2.916.653-6.924.572-6.924.572l-1.96 3.23c1.566-.514 2.848-.777 3.848-.79 4.442-.057 8.072.636 8.072.636-2.94 1.14-5.06 1.811-6.358 2.012-3.405.526-6.267-.058-6.267-.058l-2.354 4.867c1.903-.96 3.365-1.51 4.388-1.647 4.579-.617 7.852 0 7.852 0-3.403 1.945-5.831 3.112-7.286 3.502-2.32.62-5.814 0-5.814 0l-1.226 5.317c1.335-.909 2.502-1.456 3.502-1.64 4.303-.793 8.235-.523 8.235-.523-2.925 2.096-5.023 3.337-6.294 3.724-3.227.98-5.959 0-5.959 0l-.833 5.459c1.53-1.065 2.675-1.68 3.435-1.845 5.128-1.116 8.06-.656 8.06-.656-3.184 2.32-5.398 3.718-6.644 4.194-3.292 1.258-5.495.444-5.495.444l-.484 5.984c1.526-1.631 2.76-2.694 3.703-3.189 3.728-1.954 6.936-2.388 6.936-2.388-1.99 2.682-3.544 4.444-4.66 5.284-2.745 2.068-6.013 2.754-6.013 2.754l-.088 4.494c.928-1.297 1.794-2.227 2.6-2.793 1.336-.94 3.682-2.266 7.04-3.98-1.219 2.958-2.399 5.027-3.54 6.207-1.14 1.18-2.846 2.097-5.117 2.75l1.1 5.484c.56-1.725 1.14-2.934 1.742-3.626 1.07-1.228 2.995-2.9 5.778-5.015-1.134 3.35-2.143 5.685-3.024 7.007-.881 1.322-2.208 2.487-3.98 3.498l2.182 4.963c.042-1.619.496-3.21 1.365-4.774.868-1.564 2.468-3.676 4.8-6.334-.01 2.393-.122 4.088-.337 5.088-.252 1.174-1.12 2.611-1.38 3.347-.593 1.677-1.636 3.18-3.128 4.509l2.972 4.535c.056-2.116.37-3.937.94-5.464.57-1.526 1.668-3.484 3.293-5.87.12 3.747.016 6.447-.313 8.102-.329 1.655-1.124 3.475-2.384 5.46l3.491 3.582c-.111-2.893-.068-4.856.13-5.892 1.005-5.273 2.397-7.364 2.397-7.364.477 3.51.68 6.176.611 7.998-.06 1.556-.459 3.957-1.197 7.202l5.044 3.596c-.832-2.475-1.306-4.085-1.42-4.831-.34-2.205-.037-5.502.911-9.893 1.114 2.773 1.816 5.044 2.107 6.814.167 1.016.71 3.741.63 5.386-.04.814-.11 1.868-.212 3.162 2.29 1.392 4.081 2.6 5.371 3.623 1.29 1.022 3.044 2.625 5.263 4.808l-.777.59z"
          fill="#BD9E54"
        />
        <text
          fontFamily="TTNormsPro-Bold, TT Norms Pro"
          fontSize="12"
          fontWeight="bold"
          fill="#000"
          style={{ fontSize: 12, fontWeight: 600 }}
        >
          <tspan x="50%" y="50" textAnchor="middle">
            {title}
          </tspan>
        </text>
        <text
          fontFamily="TTNormsPro-Medium, TT Norms Pro"
          fontSize="12"
          fontWeight="400"
          fill="#222"
          style={{ fontSize: 12 }}
        >
          <tspan x="50%" y="64" textAnchor="middle">
            {subtitle}
          </tspan>
        </text>
        <text
          fontFamily="TTNormsPro-Medium, TT Norms Pro"
          fontSize="12"
          fontWeight="400"
          fill="#BD9E54"
          style={{ fontSize: 12, fontWeight: 600 }}
        >
          <tspan x="50%" y="93" textAnchor="middle">
            {year}
          </tspan>
        </text>
        <g
          transform="translate(70.000000, 3.000000)"
          fill="#BD9E54"
          fillRule="nonzero"
          height="30"
          width="20"
        >
          <Logo logo={logo} height="30" width="20" />
        </g>
      </g>
    </svg>
  )
}

Award.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  logo: PropTypes.oneOf(['apple', 'android', 'play']),
}

export function AndroidExcellence() {
  return (
    <Award
      title="Android excellence"
      subtitle="Google play"
      year={2018}
      logo="android"
    />
  )
}

export function BestOfGooglePlay() {
  return (
    <Award
      title="Best of Google Play"
      subtitle="Google play"
      year="2018"
      logo="play"
    />
  )
}

export function EditorsChoice() {
  return (
    <Award
      title="Editors choice"
      subtitle="App store"
      year="2018"
      logo="apple"
    />
  )
}

export function AppOfTheDay() {
  return (
    <Award
      title="App of the Day"
      subtitle="App store"
      year="2019"
      logo="apple"
    />
  )
}

function Awards() {
  const { ref, width } = useBoundingRect()
  const showAll = width > 850
  return (
    <div className="w-full my-64 max-w-1024 mx-auto">
      <div className="grid grid-flow-col gap-3 md:gap-6" ref={ref}>
        {showAll && <AndroidExcellence />}
        <BestOfGooglePlay />
        <EditorsChoice />
        <AppOfTheDay />
      </div>
    </div>
  )
}

export default Awards
